var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reservation-status-wrapper"},[_c('ReservationAlert',{staticClass:"alert--fullWidth mb-0",attrs:{"title":_vm.confirmationTitle,"subtitle":_vm.confirmationSubtitle,"variant":_vm.alertVariant}}),_c('div',{staticClass:"reservation-status-wrapper__body"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }